/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method, payload) {
  if (method === "post") {
    return api
      .post(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  } else {
    return api
      .get(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  }
}

export async function loadPurchaseInvoiceDetails(salesInvoiceList) {
  return await api
    .post(`/org/getpurchaseinvoice`, salesInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadPurchaseBarcodeDetails(salesInvoiceList) {
  return await api
    .post(`/org/getpurchasebarcodedata`, salesInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadPurchasePrintDetails(purchaseInvoiceList) {
  return await api
    .post(`/org/getpurchaseinvoicereceipt`, purchaseInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadPurchasePrintReceiptDetails(purchaseReceipt) {
  return await api
    .post(`/org/getpurchaseinvoicereceipt`, purchaseReceipt)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadPurchaseImportRamDetails(purchaseReceipt) {
  return await api
    .post(`/masters/getramtype`, purchaseReceipt)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadPurchaseBarcodeUpdateDetails(purchaseBarcode) {
  return await api
    .post(`/org/getbarcodeforupdate`, purchaseBarcode)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadScanBarcodeDetails(purchaseBarcode) {
  return await api
    .post(`/org/getdropdownbarcodedataforupdates`, purchaseBarcode)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadDashboardTransactionsDetails(transactionsList) {
  return await api
    .post(`/org/getdashboardtransaction`, transactionsList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadTotalSalesDetails(transactionsList) {
  return await api
    .post(`/org/totalsalespi`, transactionsList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadTotalPaidDetails(transactionsList) {
  return await api
    .post(`/org/totalgetpaidpi`, transactionsList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadTotalUnPaidDetails(transactionsList) {
  return await api
    .post(`/org/totalgetunpaidpi`, transactionsList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function createPurchaseInvoiceDetails(purchaseInvoiceList) {
  return await api
    .post(`/org/createpurchaseinvoice`, purchaseInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

//party vendor address
export async function loadPartyVendorAddressDetails(addressList) {
  return await api
    .post(`/org/getpartyorvendoraddress`, addressList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function createPartyVendorAddressDetails(partyAddress) {
  return await api
    .post(`/org/addpartyorvendorshippingaddress`, partyAddress)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadPartiesCategoryDetails(purchaseInvoiceList) {
  return await api
    .post(`/org/getpartycategory`, purchaseInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function createPartiesCategoryDetails(purchaseInvoiceList) {
  return await api
    .post(`/org/createpartycategory`, purchaseInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function updatePurchaseInvoiceDetails(salesInvoiceList) {
  return await api
    .put(`/org/updatepurchaseinvoice`, salesInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function deletePurchaseInvoiceDetails(salesInvoiceList) {
  return await api
    .post(`/org/deletepurchaseinvoice`, salesInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadPartiesTransactionDetails(purchaseInvoiceList) {
  return await api
    .post(`/org/getpartytransaction`, purchaseInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

const remotes = {
  loadPurchaseInvoiceDetails,
  loadPurchaseBarcodeDetails,
  loadPurchasePrintDetails,
  loadPurchasePrintReceiptDetails,
  loadPartyVendorAddressDetails,
  createPartyVendorAddressDetails,
  loadPartiesTransactionDetails,
  createPurchaseInvoiceDetails,
  loadRecordsMetaData,
  updatePurchaseInvoiceDetails,
  deletePurchaseInvoiceDetails,
  loadPartiesCategoryDetails,
  createPartiesCategoryDetails,
  loadDashboardTransactionsDetails,
  loadTotalSalesDetails,
  loadTotalPaidDetails,
  loadTotalUnPaidDetails,
  loadPurchaseImportRamDetails,
  loadPurchaseBarcodeUpdateDetails,
  loadScanBarcodeDetails,
};

export default remotes;
